import React from 'react'
import Stage11 from '../../images/Stage1-1.svg'
import Stage12 from '../../images/Stage1-2.svg'
import Stage13 from '../../images/Stage1-3.svg'

import Stage21 from '../../images/Stage2-1.svg'
const Stage22 = 'https://djhonz7dexnot.cloudfront.net/062585d01838e7fb68153dbb323f25c8677e12bf.png'
const Stage23 = 'https://djhonz7dexnot.cloudfront.net/bec8879b8e812fa7e51a59fcc16ddcd05dcda2b3.png'

const Scifiction = {
  template : 1,
  storyPoints: [
    {
      key: 1,
      point:
        'सबसे अहम मुद्दा - उपन्यास के हर chapter के अंत में दिलचस्प सवाल या किसी विज्ञान तंत्र समययात्रा, प्लेटिनरी रोमांस और साइबरनेटिक्स हाॅरर-थ्रीलर का scene के साथ हो जिससे पाठकों की रूचि बनी रहे ।',
    },
    {
      key: 2,
      point:
        'Narration past में हो इस बात का ध्यान रखें! और narration ज़्यादा से ज़्यादा 100 शब्दों का हो ।',
    },
    {
      key: 3,
      point: (
        <>
          डायलाॅग नरेटिव्ह फॉरमॅट में हो, ना की ड्रॅमॅटिक फाॅरमॅट में जैसे की
          <br />
          a. ""आर्य- में हुं सृष्टी का संरक्षक, विज्ञान का समिकरण!""
          <br />
          b. समय से परे एक ऐसा योद्धा जिसने लोगो पर आने वाली विपत्तियों को दुर
          किया, ""अर्जुन हे वो! सुपर अर्जुन जो दुष्टो का विनाषक है ! वो ही है आज
          का सुपर अर्जुन!""
        </>
      ),
    },
    {
      key: 4,
      point: (
        <>
          {' '}
          उपन्यास में दो conflict ( संघर्ष ) होने चाहिए
          <br /> a.एक मुख्य संघर्ष - जिसपे आपकी उपन्यास का पूरा a plot निर्भर हो
          !
          <br /> b.दूसरा उप संघर्ष - जिससे कहानी में रोमांच बरकरार रहे, और आपकी
          उपन्यास का emotional graph (भावनिक उतार- चढ़ाव) सही तरीके से प्रदर्शित
          होता रहे |
        </>
      ),
    },
    {
      key: 5,
      point: 'उपन्यास लिखते वक़्त punctuation का ध्यान रखें',
    },
  ],
  StageContent: [
    {
      bgColor: '#F8F9FF',
      headingbgColor: '#D7DBF5',
      stageheading: 'stage 1 ',
      stageSubHeading: 'Stage 1 starts from 15 July',
      tableContent: [
        {
          title: 'Last Date to complete 20k words',
          img: '⌛',
          date: '30th July',
        },
        {
          title: 'Results on ',
          img: '🎉',
          date: '9th Aug',
        },
      ],
      stageContent: (
        <>
          सभी लेखको को अपनी उपन्यास के 20,000 शब्द दिए गए अवधी से पहले पूरे करने
          होंगे। तभी आप स्टेज 1 के पात्र होंगे।
          <br />
          1. आपकी उपन्यास Sci-Fi की शैली में होनी चाहिए, जिसमें विज्ञान और मानव
          की अद्भुत पहेलियाँ हो।
          <br />
          2. Top 5 लेखक होगें हकदार हमारे इस आकर्षक इनाम के
          <br />
          3. प्रत्येक लेखक केवल एक पुरस्कार के लिए पात्र है
        </>
      ),
      firstPrize: Stage11,
      secondPrize: Stage12,
      thirdPrize: Stage13,
      rank4And5Prize: '₹750/-',
      isLive: true,
    },
    {
      bgColor: '#F2F2F2',
      headingbgColor: '#DCDCDA',
      stageheading: 'stage 2',
      stageSubHeading: 'Stage 2 में बरक़रार रहने के लिए उपन्यास लिखते रहें।',
      tableContent: [
        {
          title: 'The last date to complete 50,000 words ',
          img: '⌛',
          date: '14th Aug',
        },
        {
          title: 'Results on ',
          img: '🎉',
          date: '24th Aug',
        },
      ],
      stageContent: (
        <>
          सभी लेखको को अपनी उपन्यास के 50,000 शब्द दिए गए अवधी से पहले पूरे करने
          होंगे। तभी आप स्टेज 2 के पात्र होंगे।
          <br />
          1. अपनी उपन्यास के 30,000 शब्द पूरे करने के बाद अगर आपकी कहानी रीडर्स
          द्वारा सबसे ज्यादा पसंद की जाती है तो वो उपन्यास हमारे Writer Benefit
          Program के लिए भी चुनी जाएगी।
          <br /> 2. Top 10 लेखक होगें हकदार हमारे इस आकर्षक इनाम के।
          <br /> 3. विजेताओं को सर्टिफिकेट से सम्मानित किया जाएगा।"
        </>
      ),
      firstPrize: Stage21,
      secondPrize: Stage22,
      thirdPrize: Stage23,
      lowerRankCombinedPrizeTitle:<>Rank 4th to 10th </>,
      rank4And5Prize: '₹1000/-',
      isLive: true,
    },
  ],
  exampleNovels: [
    {
      title:
        'Rudra-The Superhero | रूद्र-द सुपर हीरो | Author-Prashanth N Samat',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/b4d5b1fa542da0ec19171986e2dd1b2cf8df117a.webp',
      novelLink:
        'https://www.pocketnovel.com/novel/b06485b43b4517e0098a3988a01a5e0c8f3162e1',

      novelId: 'b06485b43b4517e0098a3988a01a5e0c8f3162e1',
    },
    {
      title: 'Super Arjun | सुपर अर्जुन | Author - Mahendra Kumar',
      novelImgLink:
        'http://djhonz7dexnot.cloudfront.net/f83780c4703b45686f5e4b7a8457c815982b623e.webp',
      novelLink:
        'https://www.pocketnovel.com/novel/8c01e31876ced3b32c5cab6ca6e3b9640526fd5b',
      novelId: '8c01e31876ced3b32c5cab6ca6e3b9640526fd5b',
    },
  ],
  FAQs: [
    {
      question: 'How to enter a book into the contest ?',
      answer:
        'For books created after contest start date, Go to the book & click on "Edit Novel" & select the contest & Save Changes.',
    },
    {
      question: 'When will the awards be given to the author ?',
      answer:
        'The awards will be sent within thirty days after the results are announced.',
    },
  ],
  constants: {
    BannerDesktopImage:
      'https://djhonz7dexnot.cloudfront.net/4aa426fe1dc33a6ca45822cf1687594d017417b1.jpg',
    BannerMobileImage:
      'https://djhonz7dexnot.cloudfront.net/ba34f004d27279c8037a28356ebbd0556190c351.jpg',
    heading: 'Science Fiction लेखन',
    subHeading: 'विज्ञान और मानव की अद्भुत पहेली',
    bannerButton: 'JOIN THE CONTEST & WRITE',
    section_1_Heading: (
      <>
        प्रतियोगिता स्वरुप <span role="img"> 🏁 </span> ये प्रतियोगिता दो भागों
        में आयोजित की जाएगी{' '}
      </>
    ),
    prizeSubheading:
      'First prize will have the opportunity to possibly become an audio book with revenue share',
    stageButton: 'Enter Contest',
    section_2_Heading: 'Receive Certificate for your Literary Excellence',
    section_3_Heading: 'उदाहरण के लिए हमारी कुछ Science Fiction लेखन',
    novelContent: 'Read now',
    section_4_Heading: 'उपन्यास लिखने के 5 आसान तरीके',
    earnHeading: <>Earn Upto 10 Lakh <br/> Per Year</>,
    earnSubheading: (
      <>
        After completion of 30K words you can enter into <br />
        Writer’s Benefit Program
      </>
    ),
    earnSectionButton: 'Learn more about the program',
    section_5_Heading: 'Frequently Asked Questions ⁉️',
    contestId: '2f524f3f930d04f9d7439070ed749819bf40bcb9',
    defaultReferrer: 'contest_sci_fiction',
    visibility: 'india',
  },
  participation_certificate_image:
    'https://djhonz7dexnot.cloudfront.net/827906bac4aed3a5ad4ee81eb03d27cb63982c2f.png',
  WinnersStage1: [
    {
      position : 1.1,
      AuthorName : "Saabi",
      NovelTitle : "My handsome Monster",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/793c2c865a4dd22b64e117403f65bd0d0ecb44d0.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/68692d1d72e2d6905fd119369be899602a28f84e",
      id: "68692d1d72e2d6905fd119369be899602a28f84e",
      Reward : "₹7500"
    },
    {
      position : 1.2,
      AuthorName : "Muskan Kumari",
      NovelTitle : "Fake Robot Wife",
      ImageUrl : "	https://djhonz7dexnot.cloudfront.net/93dd214bd2a4eecc57122a14c9f10b03b17dd548.jpeg",
      NovelUrl : "https://www.pocketnovel.com/novel/0744ab541813e911227ff3b6e9764af4b74ef186",
      id: "0744ab541813e911227ff3b6e9764af4b74ef186",
      Reward : "₹4500"
    },
    {
      position : 1.3,
      AuthorName : "Pooja Hardik Patel",
      NovelTitle : "My Robotic Hubby",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/140f3a244e0958031b082085e337671e388b33f8.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/1ab3b1c055275992725e63ffe99d73659c42d5f0",
      id: "1ab3b1c055275992725e63ffe99d73659c42d5f0",
      Reward : "₹1500"
    },
    {
      position : 1.4,
      AuthorName : "Sonali Singh",
      NovelTitle : "My Robot Wife",
      ImageUrl : "	https://djhonz7dexnot.cloudfront.net/200238d30e6e1f5bd3e9beb8d5523c974f5240cf.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/33a3ce8cce2884d26ef62121877de1ef1ee66498",
      id: "33a3ce8cce2884d26ef62121877de1ef1ee66498",
      Reward : "₹750"
    },
    {
      position : 1.5,
      AuthorName : "Abhishek",
      NovelTitle : "SUPER HUMAN",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/3749acfd0c9b6359876441f16f3ed1fc773af493.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/ce00a980e4a339d12429fd400b603d9f95dc58b5",
      id: "ce00a980e4a339d12429fd400b603d9f95dc58b5",
      Reward : "₹750"
    },
  ],
  WinnersStage2: [
    {
      position : 1.1,
      AuthorName : "Priyanka Dheeman",
      NovelTitle : "My Husband is Super Human",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/a00e30f45b619f7b61d64826a419e2c47f72b8cd.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/6bd5bfd6d64ceb090d597e5976af6658662db66d",
      id: "6bd5bfd6d64ceb090d597e5976af6658662db66d",
      Reward : "₹17500"
    },
    {
      position : 1.2,
      AuthorName : "Daksh",
      NovelTitle : "Divyansh",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/59bc6f0afdaf24ac110330e3550c909504bff108.jpeg",
      NovelUrl : "https://www.pocketnovel.com/novel/0b8ac2b26268ea5593ee404551b16c080039bc7f",
      id: "0b8ac2b26268ea5593ee404551b16c080039bc7f",
      Reward : "₹7000"
    },
    {
      position : 1.3,
      AuthorName : "Jatin Singhal",
      NovelTitle : "The Super Warrior",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/c0b754869d82df69d911abde843ed15f526fe45f.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/207f6ac7821aca5e9a58e811892d7a76ac6c542f",
      id: "207f6ac7821aca5e9a58e811892d7a76ac6c542f",
      Reward : "₹3000"
    },
    {
      position : 1.4,
      AuthorName : "Omkar Chauhan",
      NovelTitle : "Lightning Of The Sky",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/d0de80f749103d8bf8463e11225f79912b2e97e8.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/044e5377a7b01784f8bba9cec3dd7cb0d09e17fb",
      id: "044e5377a7b01784f8bba9cec3dd7cb0d09e17fb",
      Reward : "₹1000"
    },
    {
      position : 1.5,
      AuthorName : "Ranbir Singh",
      NovelTitle : "Aryan: The Superhero",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/d7435e49fb1d405e3e23d6ceacb02e56f71dd6d6.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/b4a063ffb7f862ffd70065d2f112a2b77d6d81b3",
      id: "b4a063ffb7f862ffd70065d2f112a2b77d6d81b3",
      Reward : "₹1000"
    },
    {
      position : 1.6,
      AuthorName : "Jyoti",
      NovelTitle : "Narayani: Robot ya Insan",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/52e68abaa6eb3e78621f7be3f4bfc0d50839a729.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/6a10227f4687155408c55d93e9211de4ad1c04a4",
      id: "6a10227f4687155408c55d93e9211de4ad1c04a4",
      Reward : "₹1000"
    },
    {
      position : 1.7,
      AuthorName : "Tanya",
      NovelTitle : "Rudransh : Ek Anhoni",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/fdfec2e783a1f7ef63efeac0437bcc9fcf5d1be9.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/8b86040a1b4b0cce6754d28b95f402f6e0be31bc",
      id: "8b86040a1b4b0cce6754d28b95f402f6e0be31bc",
      Reward : "₹1000"
    },
    {
      position : 1.8,
      AuthorName : "Nitesh",
      NovelTitle : "Angelina : The Woman Of Miracle",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/c68bdb894abec91f84597a344471a3a89842e052.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/64ca54e4a3ea8da210a9a418b7b37345d56a918b",
      id: "64ca54e4a3ea8da210a9a418b7b37345d56a918b",
      Reward : "₹1000"
    },
    {
      position : 1.9,
      AuthorName : "Amrita",
      NovelTitle : "Rajani: Ek Machine Ya Superwomen",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/2273bf3e1482966bce2a6e282af93cf970311ded.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/c749f9c71fda9018709347923d1ffb474307d5b8",
      id: "c749f9c71fda9018709347923d1ffb474307d5b8",
      Reward : "₹1000"
    },
    {
      position : 2,
      AuthorName : "Shashank Dilipkumar Patil",
      NovelTitle : "Aryan: The Time Traveler",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/dd1be5beef2e74cfee4511753969b592616b0e72.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/e4fc9808806f6e773144ecb965b8fc774e5dd1ca",
      id: "e4fc9808806f6e773144ecb965b8fc774e5dd1ca",
      Reward : "₹1000"
    },
  ],
}

export default Scifiction
